import { useEffect, useState } from "react";
import {
   Row,
   Col,
   Select,
   DatePicker,
   InputNumber,
   Modal,
   Form,
   message
} from "antd";
import { getAllUsers } from "../../services/usersApi";
import dayjs from "dayjs";

import {
   createSalesTarget,
   updateSalesTarget
} from "../../services/salesTargetService";
const SalesTargetModal = ({ open, onCancel, onSuccess, editData = null }) => {

   const [form] = Form.useForm();
   const [loading, setLoading] = useState(false);
   const [users, setUsers] = useState([]);

   // Load Staff Users
   const loadUsers = async () => {
      try {

         setLoading(true);

         const res = await getAllUsers();

         const staffUsers = res.data.filter(
            (user) =>
               user.role_name === "staff" &&
               user.status === "active"
         );

         setUsers(staffUsers);

      } catch (err) {

         console.error(err);

      } finally {

         setLoading(false);

      }
   };

   useEffect(() => {

      if (editData) {

         form.setFieldsValue({

            sales_person_id: editData.sales_person_id,

            start_date: dayjs(editData.start_date),

            end_date: dayjs(editData.end_date),

            target_amount: Number(editData.target_amount),

            commission_amount: Number(editData.commission_amount)

         });

      } else {

         form.resetFields();

      }

   }, [editData, form]);


   const handleSubmit = async (values) => {

      try {

         setLoading(true);

         const payload = {

            ...values,

            start_date: values.start_date.format("YYYY-MM-DD"),

            end_date: values.end_date.format("YYYY-MM-DD")

         };

         if (editData) {

            await updateSalesTarget(editData.id, {
               ...payload,
               status: editData.status
            });

            message.success("Target updated successfully.");

         } else {

            await createSalesTarget(payload);

            message.success("Target created successfully.");

         }

         form.resetFields();

         onSuccess();

      } catch (err) {

         message.error(err.message || "Something went wrong");

      } finally {

         setLoading(false);

      }

   };

   useEffect(() => {
      if (open) {
         loadUsers();
      }
   }, [open]);

   return (
      <Modal
         open={open}
         title={editData ? "Edit Sales Target" : "Add Sales Target"}
         onCancel={onCancel}
         onOk={() => form.submit()}
         confirmLoading={loading}
         width={700}
      >
         <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
         >
            <Row gutter={16}>

               <Col span={24}>
                  <Form.Item
                     label="Sales Person"
                     name="sales_person_id"
                     rules={[
                        {
                           required: true,
                           message: "Please select sales person"
                        }
                     ]}
                  >
                     <Select
                        placeholder="Select Sales Person"
                        loading={loading}
                        options={users.map(user => ({
                           label: user.name,
                           value: user.id
                        }))}
                     />
                  </Form.Item>
               </Col>

               <Col span={12}>
                  <Form.Item
                     label="Start Date"
                     name="start_date"
                     rules={[
                        {
                           required: true,
                           message: "Please select start date"
                        }
                     ]}
                  >
                     <DatePicker
                        style={{ width: "100%" }}
                        format="DD-MM-YYYY"
                     />
                  </Form.Item>
               </Col>

               <Col span={12}>
                  <Form.Item
                     label="End Date"
                     name="end_date"
                     rules={[
                        {
                           required: true,
                           message: "Please select end date"
                        }
                     ]}
                  >
                     <DatePicker
                        style={{ width: "100%" }}
                        format="DD-MM-YYYY"
                     />
                  </Form.Item>
               </Col>

               <Col span={12}>
                  <Form.Item
                     label="Target Amount"
                     name="target_amount"
                     rules={[
                        {
                           required: true,
                           message: "Please enter target amount"
                        }
                     ]}
                  >
                     <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        placeholder="Enter target amount"
                     />
                  </Form.Item>
               </Col>

               <Col span={12}>
                  <Form.Item
                     label="Commission Amount"
                     name="commission_amount"
                     rules={[
                        {
                           required: true,
                           message: "Please enter commission amount"
                        }
                     ]}
                  >
                     <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        placeholder="Enter commission amount"
                     />
                  </Form.Item>
               </Col>

            </Row>

         </Form>
      </Modal>
   );
};

export default SalesTargetModal;